import React, { useState, useEffect } from "react";
import { Table, TableColumn } from "../../../components/table";
import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import { Icon } from "@iconify/react";
import EmptyModel from "../../../components/modal/emptyModal";
// import Input from "../../../components/textfield/input";
import { useHistory } from "react-router-dom";
import { Form, Modal, Row, Col, Button, Space, Pagination, Input } from "antd";
import axios from "axios";
import "../../../assets/styles/admin/personnel.scss";
import { useParams } from "react-router-dom";

const UsersGroups = () => {
  let [formUserGroups] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [countPage, setCountPage] = useState(1);
  const [state, setState] = useState<any>([]);
  const [type, setType] = useState<string>("Create");
  const [_id, set_id] = useState<string>("");
  const { confirm } = Modal;

  const columns = [
    {
      title: "",
    },
    {
      title: "EN",
    },
    {
      title: "Users Groups",
    },
    {
      title: "Action",
      align: "center",
      colspan: 3,
    },
  ];

  const Onsubmit = async (value: any) => {
    if (type === "Create") {
      await axios.post(`/permissions/create-permission`, {
        name: value.name,
        code: value.code,
      });
    } else if (type === "Update") {
      await axios.patch(`/permissions/update-permission/${_id}`, {
        name: value.name,
        code: value.code,
      });
    }
    setIsOpen(false);
    formUserGroups.resetFields();
    setTimeout(() => getData(), 200);
  };

  const getData = async () => {
    await axios.get(`/permissions/get-permissions?page=${page}`).then((res) => {
      const data = res?.data?.data;
      setState(data);
      setCountPage(res.data.pages);
      setPage(res.data.page);
    });
  };

  const getDataUpdate = async (item: any) => {
    set_id(item?._id);
    formUserGroups.setFieldsValue({
      name: item?.name,
      code: item?.code,
    });
    setIsOpen(true);
  };
  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      okText: "ตกลง / Submit",

      onOk() {
        Delete(id);
      },
      width: "fit-content",
    });
  }
  const Delete = async (id: number) => {
    await axios.delete(`/permissions/delete-permission/${id}`).then((res) => {
      getData();
    });
  };

  function onClose() {
    formUserGroups.resetFields();
    setIsOpen(false);
    // setGroupData({ name: null, code: null });
  }

  const onchangePage = (page: any) => {
    setPage(page);
    setTimeout(() => getData(), 200);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <HeaderBar title="USERS GROUPS LIST" />
      <Modal visible={isOpen} onCancel={onClose} footer={null}>
        <Form form={formUserGroups} onFinish={Onsubmit} layout="vertical">
          {type === "Create" ? (
            <h4>สร้างชื่อกลุ่มผู้ใช้งาน/Create Group Name</h4>
          ) : (
            <h4>แก้ไขชื่อกลุ่มผู้ใช้งาน/Update Group Name</h4>
          )}
          <Row justify="center" className="modal-users-groups">
            <Col xs={18} sm={18} md={18} lg={18}>
              <p style={{ color: "#5BAEA9", fontSize: "14px" }}>
                ชื่อกลุ่มผู้ใช้งาน/Group Name
              </p>
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input title="ชื่อกลุ่มผู้ใช้งาน/Group Name" />
              </Form.Item>
              <p
                style={{
                  color: "#5BAEA9",
                  fontSize: "14px",
                  marginTop: "20px",
                }}
              >
                รหัสกลุ่มผู้ใช้งาน/Group Code
              </p>
              <Form.Item
                name="code"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input
                  className="sub-group"
                  title="รหัสกลุ่มผู้ใช้งาน/Group Code"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row
            className="button-usergroups"
            justify="center"
            style={{ marginTop: "10px" }}
          >
            <Col>
              <Space>
                <Button onClick={onClose} className="cancleButton-usergroups">
                  ยกเลิก/Cancel
                </Button>
                <Button
                  className="confirmButton-usergroups"
                  style={{
                    background: "#4d7e7f",
                    color: "#ffffff",
                  }}
                  htmlType="submit"
                >
                  บันทึกข้อมูล/Submit
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Modal>
      <div style={{ padding: "10px 40px" }}>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <MainButton
            title="CREATE USER GROUP"
            onClick={() => {
              setType("Create");
              setIsOpen(true);
            }}
          >
            <Icon icon="akar-icons:plus" width="24" height="24" color="#FFFF" />
          </MainButton>
        </div>
        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {state.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="15%">{item.code}</TableColumn>
                <TableColumn width="50%">{item.name}</TableColumn>
                <TableColumn width="5%" align="center">
                  <div
                    onClick={() => {
                      getDataUpdate(item);
                      setType("Update");
                    }}
                  >
                    <Icon
                      icon="el:pencil-alt"
                      color="#5baea9"
                      width="20"
                      height="20"
                    />
                  </div>
                </TableColumn>
                <TableColumn width="5%" align="center">
                  <div
                  // onClick={() =>
                  //   history.push(
                  //     `usersgroups/list/${item._id}/usersgroupssetting`
                  //   )
                  // }
                  >
                    <Icon
                      icon="fluent:data-usage-settings-20-regular"
                      color="#5baea9"
                      width="20"
                      height="20"
                    />
                  </div>
                </TableColumn>
                <TableColumn width="5%" align="center">
                  <div onClick={() => showDeleteConfirm(item._id, item.name)}>
                    <Icon
                      icon="icomoon-free:bin"
                      width="20"
                      height="20"
                      color="#FF6760"
                    />
                  </div>
                </TableColumn>
              </tr>
            ))}
          </Table>
          <Row justify="end" className="pagination-agency">
            <Pagination
              defaultCurrent={page}
              total={countPage}
              onChange={(e: any) => {
                onchangePage(e);
              }}
            />
          </Row>
        </div>
      </div>
    </div>
  );
};
export default UsersGroups;
